import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Eye } from "lucide-react";

export function MailPreviewButton({ payload, disabled, testid = "mail-preview-button" }) {
  const [data, setData] = useState(null);

  const open = async () => {
    try { const r = await api.post("/email/preview", payload); setData(r.data); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  return (
    <>
      <Button type="button" variant="outline" onClick={open} disabled={disabled} data-testid={testid}>
        <Eye size={15} className="mr-1.5" /> Vorschau
      </Button>
      <Dialog open={!!data} onOpenChange={(o) => { if (!o) { setData(null); } }}>
        <DialogContent className="max-w-2xl" data-testid="mail-preview-dialog">
          <DialogHeader>
            <DialogTitle>Vorschau</DialogTitle>
            <DialogDescription>So sieht die Mail beim Empfänger aus (Signatur wird von Microsoft 365 angehängt).</DialogDescription>
          </DialogHeader>
          <div className="text-sm"><span className="text-slate-500">Betreff:</span> <b data-testid="mail-preview-subject">{data?.subject}</b></div>
          <iframe title="Mail-Vorschau" sandbox="" srcDoc={data?.html || ""} className="w-full h-[420px] border border-slate-200 rounded-lg bg-white" data-testid="mail-preview-frame" />
        </DialogContent>
      </Dialog>
    </>
  );
}
